export default __webpack_public_path__ + "static/media/beispiel_zaehler_2.cbae5d22.png";